import "../types/index.js";

import { ApiService } from "./ApiService.js";

export class SessionApiService extends ApiService {
  /**
   * @param {string} videoFormat
   * @returns {Promise<{redirectUrl: string}>}
   */
  async setFormat(videoFormat) {
    const response = await this.put("/api/session", { videoFormat });
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      throw this.buildApiError(response, "Error updating supported formats");
    }
  }
}
